import React from 'react';
import { Dialog, List, ListItem, Typography, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import ScheduleIcon from '@material-ui/icons/Schedule';

import InfoListItem from '../InfoListItem';

import useCar from '../../../../../../context/useCar';
import { ToggleRPC, useTranslations } from 'components/utilities';
import { areTheSameDays } from 'helpers';
const PickUpTimeInfoListItem = () => {
	const { t } = useTranslations();

	const {
		pickupTime,
		handleChangePickupTime,
		carDetails: {
			pickupTime: { is_office_open_at_pickup }
		},
		pickupTimeList,
		pickupTimeNow,
		pickupDate
	} = useCar();

	const isOfficeWorking = pickupTimeList.length > 0;

	const messages = [
		is_office_open_at_pickup ? '' : t('car.officeCloseNow'),
		isOfficeWorking ? '' : t('car.officeCloseToday')
	];

	const message = messages
		.filter((message) => !!message)
		.map((message) => <div key={message}>{message}</div>);

	return (
		<ToggleRPC>
			{({ on, toggle }) => (
				<>
					<Dialog open={on} onClose={toggle} fullWidth maxWidth="xs">
						<List>
							{areTheSameDays(new Date(), pickupDate) && (
								<ListItem
									button
									selected={pickupTime === pickupTimeNow}
									onClick={() => {
										handleChangePickupTime(pickupTimeNow);
										toggle();
									}}
								>
									<Typography>{t('car.now')}</Typography>
								</ListItem>
							)}
							{pickupTimeList.map(({ value }) => (
								<ListItem
									key={value}
									button
									selected={pickupTime === value}
									onClick={() => {
										handleChangePickupTime(value);
										toggle();
									}}
								>
									<Typography>{value}</Typography>
								</ListItem>
							))}
						</List>
					</Dialog>

					<InfoListItem
						button={isOfficeWorking}
						onClick={isOfficeWorking ? toggle : undefined}
						icon={ScheduleIcon}
						title={t('car.pickupTime')}
						info={
							<Grid
								container
								spacing={2}
								alignItems="center"
								wrap="nowrap"
							>
								{message.length > 0 && (
									<Grid item xs="auto">
										<Alert severity="warning">
											{message}
										</Alert>
									</Grid>
								)}
								<Grid item xs="auto">
									{pickupTime === pickupTimeNow
										? t('car.now')
										: pickupTime}
								</Grid>
							</Grid>
						}
					/>
				</>
			)}
		</ToggleRPC>
	);
};

export default PickUpTimeInfoListItem;
